/**
 * Normalizes a UUID string to a standard format with dashes.
 * Accepts both dashed and un-dashed formats.
 * @param uuid - The UUID string to normalize
 * @returns The normalized UUID string
 */
export function normalizeUUID(uuid: string): string {
  try {
    // If it already has dashes and looks like a valid UUID, return as-is
    if (
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        uuid,
      )
    ) {
      return uuid.toLowerCase();
    }

    // Otherwise, reformat raw 32-char hex string to standard UUID format
    if (/^[0-9a-f]{32}$/i.test(uuid)) {
      return uuid
        .replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5')
        .toLowerCase();
    }

    // If neither format matches, return original
    return uuid;
  } catch (e) {
    console.error('Error normalizing UUID:', e);
    // If any error in formatting, return original
    return uuid;
  }
}
